import { defineComponent, ref, useCssModule } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { LIST_SLIDER_LIMIT } from '~/components/ListSlider';
import { getArticleInfo, randomNumber } from '~/utils';
import { shuffleArray } from '~/utils/shuffleArray';
import { useDuck } from '~/services';
export default defineComponent({
    name: 'FranchiseSliderSimilar',
    props: {
        articleId: {
            default: -1,
            type: Number,
        },
    },
    setup(props, { root }) {
        const css = useCssModule();
        const duck = useDuck();
        const articles = ref([]);
        const randomOffset = ref(getRandomFranchiseOffset());
        const shouldRender = ref(true);
        const total = ref(0);
        /**
         * Fetch similar franchises task
         */
        const fetchSimilarFranchisesTask = useTask(function* () {
            try {
                const { headers, data } = yield duck.pub.getPubFranchisesSimilarId(props.articleId, {
                    'list[limit]': String(LIST_SLIDER_LIMIT),
                    'list[offset]': String(randomOffset.value),
                });
                total.value = headers?.get('x-total-count') || 0;
                if (!data?.length) {
                    return;
                }
                articles.value = shuffleArray(data?.map((article) => ({
                    ...article,
                    ...getArticleInfo.call(root, data),
                })));
            }
            catch (error) {
                shouldRender.value = false;
                console.error(error);
            }
        })
            .keepLatest()
            .maxConcurrency(1);
        function getRandomFranchiseOffset(maxRandomNumber = LIST_SLIDER_LIMIT) {
            return randomNumber(0, maxRandomNumber) * LIST_SLIDER_LIMIT;
        }
        function handleIntersect({ observer }) {
            if (props.articleId === -1) {
                shouldRender.value = false;
                observer?.disconnect();
                return;
            }
            fetchSimilarFranchisesTask
                .perform()
                .then(() => {
                if (!articles.value.length) {
                    let maxRandomNumber = Math.floor(total.value / LIST_SLIDER_LIMIT) - 1;
                    maxRandomNumber = maxRandomNumber < 1 ? 0 : maxRandomNumber;
                    randomOffset.value = getRandomFranchiseOffset(maxRandomNumber);
                    fetchSimilarFranchisesTask.perform().then(() => {
                        if (!articles.value.length) {
                            shouldRender.value = false;
                        }
                    });
                }
            })
                .catch(() => (shouldRender.value = false))
                .finally(() => observer?.disconnect());
        }
        return {
            articles,
            css,
            fetchSimilarFranchisesTask,
            handleIntersect,
            shouldRender,
            total,
        };
    },
});
